import React, { useEffect, useRef } from "react";
import s from "./style.module.css";

const Boxes = (props) => {
  const height = 500;

  return (
    <div className={s.boxes}>
      {props.items.map((d, i) => (
        <div className={s.box} key={`box-${i}`}>
          <div className={s.title}>{d.title}</div>
          <div className={s.content}>
            {d.items.map((e, j) => (
              <div key={`box-text-${j}`}>{e}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Boxes;
